module.exports = __webpack_public_path__ + "img/navigation_xmwl.c4803704.png";